import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" fill=\"white\" id=\"icon-calendar\"><defs></defs><g><path d=\"M16 14h-2v2h2v-2zM12 14h-2v2h2v-2zM20 14h-2v2h2v-2zM24 14h-2v2h2v-2zM10 18h-2v2h2v-2zM14 18h-2v2h2v-2zM18 18h-2v2h2v-2zM22 18h-2v2h2v-2zM8 22h-2v2h2v-2zM12 22h-2v2h2v-2zM16 22h-2v2h2v-2zM20 22h-2v2h2v-2z\" /><path d=\"M22 2h-2v2h-10v-2h-2v2h-6v24h26v-24h-6v-2zM20 8h2v-2h4v4h-22v-4h4v2h2v-2h10v2zM4 26v-14h22v14h-22z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol